import React from 'react';

/**
 * AnchoredScale - 4-point scale with named anchors + "Not observed" option.
 * Props:
 *   value: number|string|null
 *   onChange: (value) => void
 *   anchors: [{value, label}] (default 4-point)
 *   showNotObserved: boolean
 *   evidenceValue: string
 *   onEvidenceChange: (text) => void
 *   evidencePlaceholder: string
 */
export function AnchoredScale({
  value, onChange, label,
  anchors = [
    { value: 1, label: 'Consistent with age and context' },
    { value: 2, label: 'Subtle or situational differences' },
    { value: 3, label: 'Clear and recurring differences' },
    { value: 4, label: 'Marked differences across the session' },
  ],
  showNotObserved = true,
  evidenceValue, onEvidenceChange, evidencePlaceholder
}) {
  const allOptions = [
    ...anchors,
    ...(showNotObserved ? [{ value: 'not_observed', label: 'Not observed' }] : [])
  ];

  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#374151', marginBottom: 10 }}>
          {label}
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {allOptions.map(opt => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(value === opt.value ? null : opt.value)}
            style={{
              padding: '6px 12px',
              borderRadius: 8,
              border: value === opt.value ? '2px solid #4A90B5' : '1.5px solid #d1d5db',
              backgroundColor: value === opt.value ? '#EBF4FA' : '#fff',
              color: value === opt.value ? '#1e6b8a' : '#4b5563',
              fontSize: '0.8125rem',
              fontWeight: value === opt.value ? 600 : 400,
              cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
          >
            {typeof opt.value === 'number' && <span style={{ fontWeight: 700, marginRight: 4 }}>{opt.value}</span>}
            {opt.label}
          </button>
        ))}
      </div>
      {onEvidenceChange && (
        <input
          type="text"
          placeholder={evidencePlaceholder || 'One concrete example if not already in the Moment Log'}
          value={evidenceValue || ''}
          onChange={e => onEvidenceChange(e.target.value)}
          style={{
            marginTop: 8, width: '100%', padding: '8px 12px', borderRadius: 8,
            border: '1px solid #e5e7eb', fontSize: '0.8125rem', color: '#374151',
          }}
        />
      )}
    </div>
  );
}
